import { render, staticRenderFns } from "./ProviderEmployees.vue?vue&type=template&id=4d99fbeb&scoped=true&"
import script from "./ProviderEmployees.vue?vue&type=script&lang=js&"
export * from "./ProviderEmployees.vue?vue&type=script&lang=js&"
import style0 from "./ProviderEmployees.vue?vue&type=style&index=0&id=4d99fbeb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d99fbeb",
  null
  
)

export default component.exports